import { Component } from '@angular/core';
import { AppState } from '../../app.state';
import { select } from '@ngxs/store';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  protected siteData = select(AppState.siteData);
}
